import { createDataStore } from "./common";

export default createDataStore({
  storeKey: "segments",
  endpoint: process.env.REACT_APP_PLACES_API_HOST + "/segments",
  idKey: "mn_segment_id"
});
